import { createSlice } from '@reduxjs/toolkit';

export const loginSlice = createSlice({
  name: 'login',
  initialState: {
    profile: null,
    try: false,
    notificationCount: 0,
  },
  reducers: {
    setProfile: (state, action) => {
      state.profile = action.payload;
    },
    setTry: (state, action) => {
      state.try = action.payload;
    },
    setNotificationCount: (state, action) => {
      state.notificationCount = action.payload;
    },
    resetNotificationCount: (state) => {
      state.notificationCount = 0;
    },
  },
});

// Actions Redux
export const {
  setProfile,
  setTry,
  setNotificationCount,
  resetNotificationCount,
} = loginSlice.actions;

export default loginSlice.reducer;
